export const company = {
  name: 'Baumpflege Fridtjof Straesser',
  shortName: 'Baumpflege Straesser',
  owner: 'Fridtjof Sträßer',
  address: {
    street: 'Bornkampsweg 38a',
    postalCode: '22926',
    city: 'Ahrensburg',
    country: 'Deutschland',
  },
  phone: {
    display: '0163 9054671',
    international: '+49 163 9054671',
    href: 'tel:+491639054671',
  },
  whatsapp: {
    number: '491639054671',
    href: 'https://wa.me/491639054671?text=Hallo%2C%20ich%20habe%20eine%20Anfrage%20zu%20Ihrer%20Baumpflege-Leistung.',
  },
  email: {
    primary: 'f.sora@pm.me',
    suggestedBusiness: 'kontakt@baumpflege-straesser.de',
    href: 'mailto:f.sora@pm.me',
  },
  domain: 'baumpflege.pages.dev',
  url: 'https://baumpflege.pages.dev',
  serviceArea: 'Schleswig-Holstein & Hamburg',
  serviceAreaCities: [
    'Hamburg',
    'Ahrensburg',
    'Bargteheide',
    'Reinbek',
    'Glinde',
    'Lübeck',
    'Norderstedt',
    'Pinneberg',
  ],
  legal: {
    taxId: 'TBD',
    vatId: 'TBD',
    insurance: 'TBD',
    certifications: ['TBD – z. B. ETW / FLL / SKT'],
  },
} as const;
